import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from '../../../common/LoadingBar';
import DocumentsRow from './DocumentsRow';
import loadingBarImage from '../../../../images/loadingBar.gif';

const DocketEntry = ({
  id,
  docket,
  redact,
  showRedactPopup,
  case_uuid,
  onGetDocuments,
  court_code,
  case_number,
  selectedDocket,
}) => {
  const docketSeq = parseFloat(docket.docket_seq) > 0 ? docket.docket_seq : null;
  const docketNumber = parseInt(docket.docket_no, 10) > 0 ? docket.docket_no : docketSeq;

  const docketNumLink =
    !docketNumber || !docket.has_pdf_link_on_pacer ? (
      docket.docket_no || null
    ) : (
      <div
        className={`view_details ${docket.colorCode}`}
        onClick={() => onGetDocuments(docket, court_code, case_number)}
      >
        <strong> {docket.docket_no || 'doc'} </strong>
      </div>
    );

  const loadingOrRedact =
    redact.seqNum === docket.docket_seq ? (
      <div className="loading-bar">
        <img src={loadingBarImage} />
      </div>
    ) : (
      <div className="update-redact faded danger right" onClick={() => showRedactPopup(docket.docket_seq)}>
        Update/Redact
      </div>
    );

  return (
    <Fragment>
      <tr key={`docket-entry-${id}`} className="details-visible">
        <td>{docket.date_filed}</td>
        <td style={{ textAlign: 'center' }}>{docketNumLink}</td>
        <td colSpan="2">
          <span dangerouslySetInnerHTML={{ __html: docket.docket_text }} />

          {showRedactPopup && loadingOrRedact}

          {docket.status === 'loading' ||
            (selectedDocket.docket_no === docket.docket_no &&
              selectedDocket.docket_seq === docket.docket_seq &&
              selectedDocket.status === 'loading' && <LoadingBar overrideShow />)}
        </td>
      </tr>
      {selectedDocket.docket_no === docket.docket_no &&
        selectedDocket.docket_seq === docket.docket_seq &&
        selectedDocket.status !== 'loading' && (
          <DocumentsRow
            id={id}
            binder={selectedDocket.binder}
            case_uuid={case_uuid}
            court_code={court_code}
            case_number={case_number}
            docket_seq={docket.docket_seq}
            docket={docket}
          />
        )}
    </Fragment>
  );
};

DocketEntry.propTypes = {
  id: PropTypes.string.isRequired,
  docket: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  redact: PropTypes.object.isRequired,
  showRedactPopup: PropTypes.func.isRequired,
  case_uuid: PropTypes.string.isRequired,
  onGetDocuments: PropTypes.func.isRequired,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
};

export default DocketEntry;



// WEBPACK FOOTER //
// ./src/components/case/docket/docketEntries/DocketEntry.jsx